<template>
    <img
        v-if="'all_employees' === clearing || 'certain_employees' === clearing"
        src="@img/schloss_icon.png"
        :title="$t('publication.employees')"
    />
    <img
        v-else
        src="@img/mitglieder_icon.png"
        :title="$t('publication.employeesAndMembers')"
    />
</template>

<script>
export default {
    props: {
        clearing: {
            type: String,
            required: true,
        },
    },
};
</script>
